import { useState } from 'react'
import { Modal } from 'components'
import axios from 'axios'
import { useAuth } from 'contexts/auth-context'
import nProgress from 'nprogress'
import Form from './form'
import toast from 'react-hot-toast'
import { lang } from 'config'

const Content = ({ success }) => {
    const { user, isSuper } = useAuth()

    const [errors, setErrors] = useState({})

    const handleSubmit = (data) => {
        nProgress.start()

        const fd = new FormData()
        fd.append("name", data.name ?? "")
        fd.append("code", data.code ?? "")
        fd.append("is_ho", data.is_ho ? "1" : "0")
        fd.append("contact", data.contact ?? "")
        fd.append("address", data.address ?? "")
        if (data.latitude !== null && data.latitude !== undefined) fd.append("latitude", String(data.latitude))
        if (data.longitude !== null && data.longitude !== undefined) fd.append("longitude", String(data.longitude))
        if (data.image) fd.append("image", data.image)
        fd.append("created_by", user?.name ?? "")

        // NEW: open_hours + display_note
        fd.append("display_note", data.display_note ?? "")
        if (data.open_hours !== undefined && data.open_hours !== null) {
            fd.append(
            "open_hours",
            typeof data.open_hours === "string" ? data.open_hours : JSON.stringify(data.open_hours)
            )
        }

        axios
            .post(`${process.env.REACT_APP_GENERIC_API_URL}/branch`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
            success()
            toast.success(response.data.message)
            })
            .catch((error) => {
            if (error?.response?.status === 422) setErrors(error.response.data.errors)
            toast.error(error?.response?.data?.message || "Request failed")
            console.log(error)
            })
            .finally(() => {
            nProgress.done()
            })
        }


    return (
        <Form errors={errors} onSubmit={handleSubmit} />
    )
}

const Create = ({ success }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => setIsOpen(true)
    const closeModal = () => setIsOpen(false)

    const handleSuccess = () => {
        closeModal()
        success()
    }

    return (
        <>
            <button onClick={openModal} className="inline-flex items-center px-4 py-3 space-x-2 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <line x1={12} y1={5} x2={12} y2={19}></line>
                    <line x1={5} y1={12} x2={19} y2={12}></line>
                </svg>
                <span>Create New</span>
            </button>
            <Modal isOpen={isOpen} onClose={closeModal} title={`${lang.create} ${lang.branch}`} content={<Content success={handleSuccess} />} />
        </>
    )
}

export default Create